import React from 'react'
import styles from '../../styles/products.module.css';

interface ProductDeliveryRobotBoxTitleProps {
    title: string;
    content: string;
    style?: string;
}

const ProductDeliveryRobotBoxTitle: React.FC<ProductDeliveryRobotBoxTitleProps> = ({ title, content, style }) => {
    return (
        <div className={`${styles.robotTitle} ${style}`}>
            <h3>{title}</h3>
            <p>{content}</p>
        </div>
    )
}

export default ProductDeliveryRobotBoxTitle;